module.exports = __webpack_public_path__ + "img/img4.6477bdd4.jpg";